// lazyload
jQuery(function($) {
  // loading
  var loadedFlag = false;

  // key visual
  var $kv = document.getElementById('js-kv');

  // gnav & site scroll
  var _mql = window.matchMedia('screen and (max-width: 767px)');
  var _mqlPc = window.matchMedia('screen and (min-width: 768px)');

  var $root = document.querySelector('html');
  var $hamburger = document.getElementById('js-gnav-trg');
  var $gnav = document.getElementById('js-gnav');
  var $gnavItem = $gnav.getElementsByClassName('js-gnav-item');
  var $layer = document.getElementById('js-modal-layer');
  var $gnavTrgElm = document.getElementById('js-main');

  var $cvbtn = document.getElementById('js-cv-btn');
  var $cvbtnTrgElm = document.getElementById('js-footer');

  var scrollPos = 0;
  var scrollPosBtm = 0;
  var gnavTrgElmRect = 0;
  var gnavTrgElmPos = 0;
  var cvbtnTrgElmHeight = 0;
  var winHeight = 0;
  var docHeight = 0;
  var offset = 0;
  var ticking = false;

  if ($('#js-loading').length) {
    $('#js-loading').imagesLoaded(function(){
      // bodyの画像数を取得
      var imgNum = imagesLoaded('body', {background: true}).images.length;
      // 読み込んだ画像の数を格納
      var loadedImg = 0;
      // 現在のプログレス値を格納
      var progressNowPosition = 0;
      // 1秒間に50回、progressMonitor()を実行する
      Timer = setInterval(progressMonitor, 1000 / 50);

      // 画像を読み込んだらloadedImgを加算する
      imagesLoaded('body', {background: true}).on('progress', function() {
        loadedImg++;
      });

      // 画像の読み込み状況をチェックし、更新する関数
      function progressMonitor() {
        // 読み込んだ画像のパーセンテージ
        var progressPosition = (loadedImg / imgNum) * 100;
        // プログレス値を現在値と目標値からイージングする
        progressNowPosition += (progressPosition - progressNowPosition) * 0.1;
        // プログレスバーの横幅を指定する
        $('#js-progress').css('width', progressNowPosition + '%');
        _prgWidth = $('#js-progress').width();

        // 読み込みが完了した場合の処理
        if (progressNowPosition >= 100) {
          clearLoadWindow();
        }

        // イージング計算を完了させる
        if (progressNowPosition > 99.9) {
          progressNowPosition = 100 + 10;
        }

      }

      // ローディング解除関数
      function clearLoadWindow() {
        clearInterval(Timer);
        $('#js-loading').addClass('is-hidden');
        $('#js-body').addClass('is-show');
        if ($kv) {
          $kv.classList.add('is-show');
        }
        loadedFlag = true;
      }

    });
  }

  // gnav & site scroll
  window.addEventListener('scroll', function() {
    if (!ticking && loadedFlag) {
      requestAnimationFrame(function() {
        ticking = false;
        scrollPos = window.pageYOffset;
        siteScrolled(scrollPos);
        if ($gnav && $gnavTrgElm) {
          toggleGnavState();
        }
        if ($cvbtn && $cvbtnTrgElm) {
          toggleCvBtn();
        }
      });
      ticking = true;
    }
  }, false);

  if ($hamburger) {
    // ▼クリック
    $hamburger.addEventListener('click', function(e) {
      if ($gnav && loadedFlag) {
        if ($gnav.classList.contains('is-active')) {
          hideNav(_mql);
        } else {
          appearNav(_mql);
        }
      }
    }, false);
  }

  if ($gnavItem.length) {
    for (var i = 0; i < $gnavItem.length; i++) {
      $gnavItem[i].addEventListener('click', function(e) {
        if ($gnav && loadedFlag) {
          if ($gnav.classList.contains('is-active')) {
            hideNav(_mql);
          }
        }
      }, false);
    }
  }

  _mqlPc.addEventListener('change', hideNav);

  function siteScrolled() {
    // 下方向にスクロールしているとき
    if (scrollPos > offset) {
      if ($root.classList.contains('site-scroll-up')) {
        $root.classList.remove('site-scroll-up');
        $root.classList.add('site-scroll-down');
      } else if (!$root.classList.contains('site-scroll-down')) {
        $root.classList.add('site-scroll-down');
      }
    // 上方向にスクロールしているとき
    } else {
      if ($root.classList.contains('site-scroll-down')) {
        $root.classList.remove('site-scroll-down');
        $root.classList.add('site-scroll-up');
      } else if (!$root.classList.contains('site-scroll-up')) {
        $root.classList.add('site-scroll-up');
      }
    }
    offset = scrollPos;
  }

  function hideNav(_mql) {
    if (_mql.matches) {
      $gnav.classList.remove('is-active');
      $layer.classList.remove('is-active');
      document.querySelector('html').classList.remove('is-locked');
      $gnav.style.height = '';
      $hamburger.classList.remove('is-active');
    } else {
      $gnav.classList.remove('is-active');
      $layer.classList.remove('is-active');
      document.querySelector('html').classList.remove('is-locked');
      $gnav.style.height = '';
      $hamburger.classList.remove('is-active');
    }
  }
  function appearNav() {
    document.querySelector('html').classList.add('is-locked');
    // $header.classList.add('is-fixed');
    // $headerLogo.classList.add('is-visible');
    if (_mql.matches) {
      _targetH = window.innerHeight;
      $gnav.style.height = _targetH + 'px';
      $gnav.scrollTo(0, - + _targetH);
    }
    $gnav.classList.add('is-active');
    $layer.classList.add('is-active');
    $hamburger.classList.add('is-active');
  }

  function toggleGnavState() {
    if ($gnavTrgElm) {
      gnavTrgElmRect = $gnavTrgElm.getBoundingClientRect();
      gnavTrgElmPos = scrollPos + gnavTrgElmRect.top;
    } else {
      gnavTrgElmPos = 0;
    }
    if (scrollPos > gnavTrgElmPos) {
      $gnav.classList.add('is-fixed');
    } else {
      $gnav.classList.remove('is-fixed');
    }
  }

  function toggleCvBtn() {
    winHeight = window.innerHeight;
    docHeight = document.body.clientHeight;
    scrollPosBtm = winHeight + scrollPos;
    cvbtnTrgElmHeight = $cvbtnTrgElm.offsetHeight;
    if (docHeight - scrollPosBtm < cvbtnTrgElmHeight) {
      if (!$cvbtn.classList.contains('is-hidden')) {
        $cvbtn.classList.add('is-hidden');
      }
    } else {
      if ($cvbtn.classList.contains('is-hidden')) {
        $cvbtn.classList.remove('is-hidden');
      }
    }
  }

});
